import './index.css';
import 'react-datepicker/dist/react-datepicker.css';
import { AppComponent } from './AppComponent';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<AppComponent />);
